import type { Observable } from 'rxjs';
import type {StateManager} from 'shared/state-manager/state-manager';
import {map} from 'rxjs/operators';

export class DerivedStateManager<STATE> implements StateManager<STATE> {

    constructor(private sourceStateManger: StateManager<STATE>, private modifier: (state: STATE) => STATE) {
    }

    getState$(): Observable<STATE> {
        return this.sourceStateManger.getState$().pipe(map(this.modifier));
    }

    requestChangeState(newParams: STATE): void {
        this.sourceStateManger.requestChangeState(newParams);
    }

    requestChangeStateParameter<T extends keyof STATE>(parameterName: T, newValue: STATE[T]): void {
        this.sourceStateManger.requestChangeStateParameter(parameterName, newValue);
    }

}